import PropTypes from 'prop-types';
import React from 'react';

const CancelIcon = ({ size, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
      <path d="M18.364 5.636l-12.728 12.728" />
    </svg>
  );
};

CancelIcon.propTypes = {
  size: PropTypes.number,
  style: PropTypes.objectOf(PropTypes.any),
};

CancelIcon.defaultProps = {
  size: 15,
  style: {},
};

export default CancelIcon;
